<template>
    <div  id="course">
      <div class="banner" id="banner">
    <el-carousel trigger="click" height="460px"
    :interval="5000"
    :autoplay="true"
    >
      <el-carousel-item v-for="(item,index) in banner" :key="index">
           <div class="banner-list">
              <img :src="item.picUrl" alt="" style="height:460px;width:100%" v-if="getResourceType(item.picUrl) == 'img'">
                <VideoPlay
                v-show="true"
                :videoUrl="item.picUrl"
                :height="460"
                :autoplay="true"
                :controls="false"
                :loop="true"
                :muted="false"
                preload="auto"
                :showPlay="true"
                :playWidth="96"
                zoom="cover"
                v-if="getResourceType(item.picUrl) == 'video'"
              />
           </div>
           <div class="banner-description">
            <div class="name" v-if="getResourceType(item.picUrl) != 'video'">{{item.name}}</div>
             <div class="description" v-if="getResourceType(item.picUrl) != 'video'">{{item.description}}</div>
             <div class="btn" @click="openBannerView(item)"
             :class="{mobileVid: getResourceType(item.picUrl) == 'video'}"
             :style="getResourceType(item.picUrl) == 'video' ? {'margin-top':'100px'} : ''"
             >立即查看</div>
           </div>
      </el-carousel-item>
    </el-carousel>
        </div>
        <div class="endowloadDetail-contaniner" >
                 <div class="ace-dbl-nav-channel" :class="{ fixed: isFixed }">
              <div class="mod">
                <div class="inner flex align-cen">
                    <div class="nav-text"  @click="gethisList('',-1,'pageSize')"
                    :class="{ active: currentNav == -1 }"
                    >全部</div>
                <div class="nav-text"
                 v-for="(item,index) in classfy"
                :key="index"
                :class="{ active: currentNav == index }"
                 @click="gethisList(item.id,index,'pageSize')"
                >
                    <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
                <span>
                    {{item.name}}
                </span>
                    </el-tooltip>
                </div>
                </div>
                </div>
          </div>
             <div class="product-container  flex align-cen"  v-if="dataList2.length">
                             <div class="product-card"  v-for="item in dataList2"
                             @click="openDetail(item)"
                             >
                                <img :src="item.logo" alt="">
                                  <div class="product-card-item-wrap">
                                    <div class="card-name">{{item.title}}</div>
                                    <div class="card-description">{{item.introduction || '暂无描述'}}</div>
                                    <div class="WordsLink_word-wrap">
                                        <div class="wrap-price">
                                            <div v-if="item.payType == 1" style="color:red">免费</div>
                                            <div v-else class=" flex align-cen">
                                                <div>
                                                        <span style="color:red;font-size:20px">¥{{item.minSale}}起</span> 
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mft wrap-len" style="color:#b4b7c1;font-size:13px">已更新 {{item.chapterNum}}期</div>
                                    </div>
                                </div>
                             </div>
                              <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
                        </div>
                 <div class="endowloadDetail-contaniner endowloadDetail-contaniner1" v-else>
            <span class="icon-al-wind-cry"></span>
            <p>暂无数据</p>
        </div>
        </div>
    </div>
</template>
<script>
import { bannerList,courseClassify,courseIndexPage,} from "@/api/enterprise/index" // 轮播图列表、配置详情、分类、列表、列表分页
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import VideoPlay from '@/components/VideoPlay'
import debounce from '../../utils/debounce.js' //防抖
export default {
    name:'course',
     components:{
        paginaTion,
        VideoPlay
    },
    data () {
        return {
            fristId:'',
            classfy:[],
            banner:[],
            tabPosition:'top',
            isFixed: false,
            isClick:false,
            currentNav:-1,
             currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount:0,
            dataList2:[],
            options:{},
            token1:'',

        }
    },
     mounted () {
      window.addEventListener('scroll', this.handleScroll) // 监听滑动事件  
    },
    created () {
        let that = this
         document.title = "课程中心"
        this.getBanner()
        //    异步同步执行
            this.getClassfy().then(function(){
            that.gethisList(that.fristId,-1)
            })
    },

    methods: {
    //         getEnBusinee(param) {
    //   enBusiness({}, "enterprise")
    //     .then((res) => {
    //       this.options = res.data;
    //     })
    //     .catch((err) => {
         
    //     });
    // },
           // 打开详情
        openDetail(data){
           this.$router.push({
            name:'HlrjenCourseDetail',
            query: {
              id: data.id
            }
         })
        // this.token1 = this.$locaStorage.setAge().get('token1')
        // if(this.token1){
        
        // }else{
        // }
        },
               // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.gethisList(this.fristId,this.currentNav)
      },
              handleScroll(){
            var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
         var offsetTop = document.querySelector('.banner').offsetHeight
         // 吸顶效果
        if (scrollTop > offsetTop) {
          this.isFixed = true
        } else {
          this.isFixed = false
        }
                  //防抖触发
        debounce(() => {
            this.$bus.$emit("fixedState",this.isFixed);
        }, 300)
        },
        gethisList(id,index,page){
             this.fristId = id
             this.currentNav = index
              if(page){
                this.PageSize = 10
                this.currentPage = 1
            }
            courseIndexPage({
                id:'',
                recommend:'',
                isPlat:1,
                classifyId:id,
                payType:'',
                businessId:'',
                size:this.PageSize,
                current:this.currentPage,
            },'enterprise')
            .then(res =>{
                this.dataList2 = res.data.records
                this.totalCount = res.data.total
            })
        },
         async getClassfy(){
            await courseClassify({name:''})
            .then(res =>{
                this.classfy = res.data
            })
            .catch(err =>{})
        },
         // 判断为图片还是视频
        getResourceType(url) {
         const extension = url.split('.').pop().toLowerCase(); 
         if (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'gif') 
         { return 'img'; }
          else if (extension === 'mp4' || extension === 'avi' || extension === 'mov' || extension === 'wmv') 
         { return 'video'; } 
         else { return 'unknown'; } 
         },
          // 获取轮播图
        getBanner(){
              bannerList({
              channelFirst:'和隆软件官网',
              channelSecond:'课程首页-网页端'
            },'enterprise')
            .then(res => {
             this.banner = res.data
            })
            .catch(err => {
            })
        },
              // 打开轮播图详情页
        openBannerView(data){
             if(data.particularType == '1'){
                 
                let path=data.particulars
               window.open(path,'_black')
             }else{
                  const newurl = this.$router.resolve({name: 'hlrjbannerDetail', query: {id: data.id}})
                    window.open(newurl.href,'_blank')
             }
        },
    },
}
</script>
<style lang="scss" scoped>
.ace-dbl-nav-channel{
     .inner{
                max-width: 100% !important;
                padding: 0 50px;
                .nav-text{
                    // width: 150px;
                    width: 120px;
                    text-align: center;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space:nowrap;
                }
         }
}
#course{
        .banner{
        position: relative;
        .banner-list{
            img{
                object-fit: cover;
            }
        }
        .banner-description{
            position: absolute;
            left: 8%;
            top: 144px;
            color: #fff;
            .name{
               font-size: 42px;
                color: #181818;
                line-height: 48px;
                margin-bottom: 15px;
                opacity: 1;
                min-height: 48px;
            }
            .description{
    height: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    font-size: 16px;
    color: #181818;
    line-height: 30px;
    margin-bottom: 20px;
    opacity: 1;
            }
                .btn{
                     width: 138px;
                    cursor: pointer;
                    border: none;
                   height: 42px;
                   line-height: 42px;
                    font-size: 16px;
                    text-align: center;
                    vertical-align: middle;
                    background-color: #2893f1;
                    border-radius: 1px;
                    margin-right: 20px;
                    padding: 0px 0;
                    color: #fff;
                    a{
                        color: #fff;
                    }
                }
        }
    }
         #banner{
            position: relative;
        .el-carousel__container{
            height: auto;
        }
 
    }
                .product-container{
                    max-width: 1540px;
            padding: 25px 15px 60px;
            flex-wrap: wrap;
            margin: 0 auto;
                    margin-bottom: 4px;
      .product-card{
        cursor: pointer;
       flex: 0 0 25%;
    position: relative;
    cursor: pointer;
    margin-top: 27px;
            background-color: #fff;
            box-shadow: 0 4px 20px rgba(19,19,51,0.04);
            border-radius: 4px;
            z-index: 1;
            font-size: 0;
            font-family: Microsoft YaHei;
            font-weight: 400;
            transition: box-shadow .15s;
            img{
                width: 97%;
                height: 150px;
                object-fit: cover;
                border-radius: 4px 4px 0 0;
            }
            .product-card-item-wrap{
             padding: 12px 16px 16px;
             .card-name{
                width: 97%;
                margin-bottom: 2px;
                overflow: hidden;
                color: #161616;
                font-weight: 600;
                font-size: 16px;
                line-height: 26px;
                white-space: nowrap;
                text-overflow: ellipsis;
             }
             .card-description{
                display: -webkit-box;
                margin-bottom: 12px;
                overflow: hidden;
                color: #b4b7c1;
                font-size: 14px;
                line-height: 22px;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
             }
             .WordsLink_word-wrap{
                color: #2893f1;
                font-size: 14px;
                line-height: 22px;
                cursor: pointer;
                span{
                        display: inline-block;
                    font-size: 13px;
                    margin-left: 4px;
                }
             }
            }
      }  
    }
}
@media (max-width: 640px){
    #course{
              #banner{
        .el-carousel__container{
            height: auto;
        }
        .banner-list{
            height: inherit;
            img{
                height: 100% !important;
            }
        }
        .banner-description{
            top: 60px;
            .name{
                font-size: 20px;
                line-height: 24px ;
                min-height: 24px;
            }
            .description{
                font-size: 13px;
                 line-height: 24px ;
                min-height: 24px;
                height: auto;
                width: 220px;
                 overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
            }
            .btn{
                margin-top: 0px;
            }
            .mobileVid{
                margin-left: 58%;
            }
        }
    }
        .ace-dbl-nav-channel{
            .inner{
                max-width: 100% !important;
                .nav-text{
                    margin-right: 0 !important;
                    padding: 0 10px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
          .product-container{
                padding-top: 0;
                .product-card{
                    flex:  0 0 50%;
                }
            }
    }
}
::v-deep{
    .fentotl{
        width: 100%;
        .jiange{
            width: 100%;
            text-align: center !important;
        }
    }
    @media (max-width: 640px){
         .banner{
        .el-carousel__container{
            height: auto !important;
            min-height: 270px;
        }
          .el-carousel__indicators--horizontal{
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
    .el-carousel__button{
        width: 24px;
        opacity: 1;
    }
    .is-active{
        .el-carousel__button{
        background-color: #2893f1;
        }
        
    }
    }
    }
    }
    .el-carousel__indicators--horizontal{
    bottom: 35px;
    left: 9%;
    transform: translateX(-9%);
    .el-carousel__button{
        width: 36px;
        opacity: 1;
    }
    .is-active{
        .el-carousel__button{
        background-color: #2893f1;
        }
        
    }
    }
//     .el-loading-spinner{
//   /*这个是自己想设置的 gif 加载动图*/
//   background-image:url('../../assets/images/loading4.gif');
//   background-repeat: no-repeat;
//   background-size: 300px 300px;
//   height:300px;
//   width:100%;
//   background-position:center;
//   /*覆盖 element-ui 默认的 50% 因为此处设置了height:100%,所以不设置的话，会只显示一半，因为被top顶下去了*/
//   top:40%;
//  }
// .el-loading-spinner .circular {
//  /*隐藏 之前 element-ui 默认的 loading 动画*/
 
//  display: none;
// }
// .el-loading-spinner .el-loading-text{
//  /*为了使得文字在loading图下面*/
//  margin:85px 0px;
// }
}
</style>